import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Trophy } from "lucide-react";

export default function ReferralLeaderboard() {
  const [board, setBoard] = useState(null);
  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/referrals/leaderboard"); setBoard(data); } catch {}
    })();
  }, []);

  if (!board || board.length === 0) return null;

  const MEDALS = ["🥇", "🥈", "🥉"];
  return (
    <div className="mt-4 rounded-3xl border border-slate-200 bg-white p-5" data-testid="referral-leaderboard">
      <div className="flex items-center gap-2 text-[11px] uppercase tracking-widest text-slate-500 font-bold"><Trophy size={12} /> Top referrers</div>
      <div className="mt-1 font-manrope font-bold text-slate-900">The MoneyWise Wall of Fame</div>
      <div className="mt-4 space-y-2">
        {board.map((row, i) => (
          <div key={row.user_id} className={`flex items-center gap-3 rounded-xl px-3 py-2.5 ${row.is_you ? "bg-emerald-50 border border-emerald-200" : "bg-slate-50"}`} data-testid={`leaderboard-row-${i}`}>
            <div className="w-8 h-8 shrink-0 rounded-full flex items-center justify-center font-manrope font-bold text-sm bg-white border border-slate-200">
              {row.rank && row.rank <= 3 ? MEDALS[row.rank - 1] : <span className="text-slate-500">{row.rank || "·"}</span>}
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-semibold text-slate-900 truncate">
                {row.display_name}{row.is_you && <span className="ml-1 text-[10px] uppercase tracking-widest text-emerald-700 font-bold">you</span>}
              </div>
            </div>
            <div className="font-manrope font-extrabold tabular-nums text-slate-900">{row.count}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
